import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 14;

export default ({ size = defaultSize, color = defaultIconColor, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <defs>
      <filter id="a">
        <feColorMatrix
          in="SourceGraphic"
          values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g transform="translate(-8.842 -9)" filter="url(#a)" fill="none" fillRule="evenodd">
      <g stroke={color} strokeWidth="2">
        <path d="M16 9.333v13.333M22.667 16H9.334" />
      </g>
    </g>
  </svg>
);
